module.exports = __webpack_public_path__ + "img/pt.c660cc1a.jpg";